import React, {useState} from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
//Import Images
import Image1 from '../../assets/gallery/DJI_0070.jpg'
import Image2 from '../../assets/gallery/DJI_0076.jpg'
import Image3 from '../../assets/gallery/DJI_0079.jpg'
import Image4 from '../../assets/gallery/DJI_0085.jpg'
import Image5 from '../../assets/gallery/DJI_0086.jpg'
import Image6 from '../../assets/gallery/DJI_0088.jpg'
import Image7 from '../../assets/gallery/DSC00002.jpg'
import Image8 from '../../assets/gallery/DSC00005.jpg'
import Image9 from '../../assets/gallery/DSC00008.jpg'
import Image10 from '../../assets/gallery/DSC00011.jpg'
import Image11 from '../../assets/gallery/DSC00017.jpg'
import Image12 from '../../assets/gallery/DSC00020.jpg'
import Image13 from '../../assets/gallery/DSC00023.jpg'
import Image14 from '../../assets/gallery/DSC00026.jpg'
import Image15 from '../../assets/gallery/DSC00029.jpg'
import Image16 from '../../assets/gallery/DSC00033.jpg'
import Image17 from '../../assets/gallery/DSC00039.jpg'
import Image18 from '../../assets/gallery/DSC00042.jpg'
import Image19 from '../../assets/gallery/DSC00045.jpg'
import Image20 from '../../assets/gallery/DSC00048.jpg'
import Image21 from '../../assets/gallery/DSC00054.jpg'
import Image22 from '../../assets/gallery/DSC00057.jpg'
import Image23 from '../../assets/gallery/DSC00060.jpg'
import Image24 from '../../assets/gallery/DSC00063.jpg'
import Image25 from '../../assets/gallery/DSC00066.jpg'
import Image26 from '../../assets/gallery/DSC00069.jpg'
import Image27 from '../../assets/gallery/DSC00072.jpg'
import Image28 from '../../assets/gallery/DSC00080.jpg'
import Image29 from '../../assets/gallery/DSC00083.jpg'
import Image30 from '../../assets/gallery/DSC09926.jpg'
import Image31 from '../../assets/gallery/DSC09932.jpg'
import Image32 from '../../assets/gallery/DSC09938.jpg'
import Image33 from '../../assets/gallery/DSC09941.jpg'
import Image34 from '../../assets/gallery/DSC09947.jpg'
import Image35 from '../../assets/gallery/DSC09950.jpg'
import Image36 from '../../assets/gallery/DSC09953.jpg'
import Image37 from '../../assets/gallery/DSC09959.jpg'
import Image38 from '../../assets/gallery/DSC09962.jpg'
import Image39 from '../../assets/gallery/DSC09965.jpg'
import Image40 from '../../assets/gallery/DSC09968.jpg'
import Image41 from '../../assets/gallery/DSC09977.jpg'
import Image42 from '../../assets/gallery/DSC09980.jpg'
import Image43 from '../../assets/gallery/DSC09983.jpg'
import Image44 from '../../assets/gallery/DSC09989.jpg'
import Image45 from '../../assets/gallery/DSC09992.jpg'
import Image46 from '../../assets/gallery/DSC09995.jpg'
import Image47 from '../../assets/gallery/DSC09998.jpg'

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/grid';
import './Gallery.css';

// import required modules
import { Pagination, Navigation, Grid } from 'swiper/modules';

export default function Gallery() {

  const [enlargedImage, setEnlargedImage] = useState(null);

  const openEnlargedImage = (image) => {
    setEnlargedImage(image);
  };

  const closeEnlargedImage = () => {
    setEnlargedImage(null);
  };

  return (
    <section id='gallery' className='gallery section'>
      <div className='section_title'>
          An enchanting masterpiece
          </div>
          <div className='section_subtitle'>
          View the property photos below.
          </div>
      <Swiper

        slidesPerView={2}
        grid={{
          rows: 2,
        }}
        spaceBetween={30}
        navigation={true}
        pagination={{
          type: 'fraction',
        }}
        modules={[Grid, Pagination, Navigation]}
        className="mySwiper"
        breakpoints={{
          428: {
            slidesPerView: 3,
          },
        }}
      >
        <SwiperSlide onClick={() => openEnlargedImage(Image1)}><img src={Image1} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image2)}><img src={Image2} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image3)}><img src={Image3} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image4)}><img src={Image4} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image5)}><img src={Image5} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image6)}><img src={Image6} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image7)}><img src={Image7} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image8)}><img src={Image8} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image9)}><img src={Image9} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image10)}><img src={Image10} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image11)}><img src={Image11} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image12)}><img src={Image12} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image13)}><img src={Image13} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image14)}><img src={Image14} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image15)}><img src={Image15} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image16)}><img src={Image16} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image17)}><img src={Image17} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image18)}><img src={Image18} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image19)}><img src={Image19} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image20)}><img src={Image20} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image21)}><img src={Image21} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image22)}><img src={Image22} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image23)}><img src={Image23} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image24)}><img src={Image24} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image25)}><img src={Image25} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image26)}><img src={Image26} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image27)}><img src={Image27} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image28)}><img src={Image28} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image29)}><img src={Image29} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image30)}><img src={Image30} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image31)}><img src={Image31} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image32)}><img src={Image32} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image33)}><img src={Image33} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image34)}><img src={Image34} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image35)}><img src={Image35} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image36)}><img src={Image36} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image37)}><img src={Image37} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image38)}><img src={Image38} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image39)}><img src={Image39} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image40)}><img src={Image40} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image41)}><img src={Image41} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image42)}><img src={Image42} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image43)}><img src={Image43} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image44)}><img src={Image44} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image45)}><img src={Image45} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image46)}><img src={Image46} alt='' className='image'/></SwiperSlide>
        <SwiperSlide onClick={() => openEnlargedImage(Image47)}><img src={Image47} alt='' className='image'/></SwiperSlide>
      </Swiper>


      {/* Enlarged Image */}
      {enlargedImage && (
            <div className="enlarged-gallery">
              <div className="enlarged-image-container">
                <img src={enlargedImage} alt="" className="enlarged-image" />
                <button className="close-button" onClick={closeEnlargedImage}>
                <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" fill='var(--text-color)' viewBox="0 0 24 24" id="close"><path d="M19.8534546,19.1465454L12.7069092,12l7.1465454-7.1465454c0.1871948-0.1937256,0.1871948-0.5009155,0-0.6947021c-0.1918335-0.1986084-0.5083618-0.2041016-0.7069702-0.0122681l-7.1465454,7.1465454L4.8534546,4.1465454c-0.1937256-0.1871338-0.5009155-0.1871338-0.6947021,0C3.960144,4.3383789,3.9546509,4.6549072,4.1464844,4.8535156L11.2929688,12l-7.1464844,7.1464844c-0.09375,0.09375-0.1464233,0.2208862-0.1464233,0.3534546C4,19.776062,4.223877,19.999939,4.5,20c0.1326294,0.0001221,0.2598267-0.0526123,0.3534546-0.1465454l7.1464844-7.1464844l7.1465454,7.1465454C19.2401123,19.9474487,19.3673706,20.0001831,19.5,20c0.1325073-0.000061,0.2595825-0.0526733,0.3533325-0.1463623C20.048645,19.6583862,20.0487061,19.3417969,19.8534546,19.1465454z"></path></svg>
                </button>
              </div>
            </div>
          )}


    </section>
  );
}
